// Company statistics constants
const MEMBER_COUNT = "2 million";
const COMPANY_COUNT = "2,800";

const GLOBAL_ROUTES_WITH_UPDATED_AT_SECTION = [
  "/for-members/support/",
  "/product/global/",
  "/global/for-individuals/",
  "/resources/support/mobile-app-support/",
  "/resources/support/app-store-google-play-store-login-help/",
  "/resources/support/help-finding-the-hinge-health-app/",
  "/resources/support/device-compatibility-issues-with-app/",
  "/resources/support/wifi-or-cellular-data-issues-when-downloading-app/",
  "/resources/support/step-by-step-instructions-for-app-download/",
  "/resources/support/not-enough-storage-or-memory-to-download-app/",
  "/resources/support/help-with-slow-or-blocked-app-download/",
  "/resources/support/getting-started/",
  "/resources/support/technical-support-faq/",
];

const ROUTES_FOR_GLOBAL_LOCALE_TRANSLATION = [
  "/",
  "/for-individuals/",
  "/for-individuals/eligibility-form/",
  "/for-organizations/our-approach/",
  "/product/enso/",
  "/for-organizations/",
  "/for-members/support/",
  "/product/pelvic-health/",
  "/for-organizations/healthplans/",
  "/about/contact/",
  "/about/",
  "/global/for-individuals/",
  "/for/*/",
  "/product/global/",
  "/product/precision-motion-technology/",
  "/resources/support/mobile-app-support/",
  "/resources/support/app-store-google-play-store-login-help/",
  "/resources/support/help-finding-the-hinge-health-app/",
  "/resources/support/device-compatibility-issues-with-app/",
  "/resources/support/wifi-or-cellular-data-issues-when-downloading-app/",
  "/resources/support/step-by-step-instructions-for-app-download/",
  "/resources/support/not-enough-storage-or-memory-to-download-app/",
  "/resources/support/help-with-slow-or-blocked-app-download/",
  "/resources/support/getting-started/",
  "/resources/support/technical-support-faq/",
];

const GLOBAL_LOCALES = ["fr-FR", "de-DE", "nl-NL", "en-GB", "hi-IN", "es-MX"];

const MOVE_PAGE_SLUG = "acquisition/move-bbmpilot26";

const AUD_SEGMENTS = ["hs_hd_p", "hs_o_p", "hs_hd_n", "hs_o_n"] as const;

export {
  MEMBER_COUNT,
  COMPANY_COUNT,
  GLOBAL_ROUTES_WITH_UPDATED_AT_SECTION,
  ROUTES_FOR_GLOBAL_LOCALE_TRANSLATION,
  GLOBAL_LOCALES,
  MOVE_PAGE_SLUG,
  AUD_SEGMENTS,
};
